export const normalizeStatusList = (payload) => {
  if (payload && payload.size) {
    return { status: payload.toArray() };
  }
  return undefined;
};

export const automatedJobQueryParams = ({
  jobsTeamSharingFeatureEnabled, ownership = {}, organizationId, username, statusList,
}) => {
  if (jobsTeamSharingFeatureEnabled) {
    const defaultParams = {
      auto_only: true,
      full: true,
      limit: 50,
    };

    if (ownership.type === 'team') {
      return {
        ...defaultParams,
        team_id: ownership.name,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'organization') {
      return {
        ...defaultParams,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'user') {
      return {
        ...defaultParams,
        org_id: organizationId,
        owner: ownership.name || username,
        ...normalizeStatusList(statusList),
      };
    }

    return {
      ...defaultParams,
      ...normalizeStatusList(statusList),
    };
  }

  if (ownership.type === 'organization') {
    return {
      username,
      owner_type: ownership.type,
      ...normalizeStatusList(statusList),
      subaccounts: false,
    };
  }

  return {
    username,
    org_id: organizationId,
    owner: ownership.name || username,
    owner_type: 'user',
    subaccounts: false,
    ...normalizeStatusList(statusList),
  };
};


export const buildQueryParams = ({
  jobsTeamSharingFeatureEnabled, ownership = {}, organizationId, username, statusList,
}) => {
  const defaultParams = {
    limit: 50,
  };

  if (jobsTeamSharingFeatureEnabled) {
    if (ownership.type === 'team') {
      return {
        ...defaultParams,
        team_id: ownership.name,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'organization') {
      return {
        ...defaultParams,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'user') {
      return {
        ...defaultParams,
        org_id: organizationId,
        owner: ownership.name || username,
        ...normalizeStatusList(statusList),
      };
    }

    return {
      ...defaultParams,
      ...normalizeStatusList(statusList),
    };
  }

  if (ownership.type === 'organization') {
    return {
      ...defaultParams,
      username,
      owner_type: 'organization',
      ...normalizeStatusList(statusList),
    };
  }

  return {
    ...defaultParams,
    username,
    owner_type: 'user',
    owner: ownership.name || username,
    ...normalizeStatusList(statusList),
  };
};


export const UPJobQueryParams = ({ offset, statusList }) => ({
  offset,
  ...normalizeStatusList(statusList),
});


export const manualJobQueryParams = ({ username }) => ({
  username,
  manual_only: true,
  full: true,
});
